// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    UPDATE_USER_ENTITLEMENTS: 'UPDATE_USER_ENTITLEMENTS',
    UPDATE_USER_PREFERENCES_ALL_CLAIMS_STATUS: 'UPDATE_USER_PREFERENCES_ALL_CLAIMS_STATUS',
    UPDATE_USER_PREFERENCES_ALL_CLAIM_TYPES: 'UPDATE_USER_PREFERENCES_ALL_CLAIM_TYPES',
    UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS: 'UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS',
    UPDATE_USER_PREFERENCES_ALL_PART_RETURNS_STATUS: 'UPDATE_USER_PREFERENCES_ALL_PART_RETURNS_STATUS',
    UPDATE_USER_PREFERENCES_CLAIMS_NUMBER_OF_DAYS: 'UPDATE_USER_PREFERENCES_CLAIMS_NUMBER_OF_DAYS',
    UPDATE_USER_PREFERENCES_CLAIMS_STATUS: 'UPDATE_USER_PREFERENCES_CLAIMS_STATUS',
    UPDATE_USER_PREFERENCES_CLAIM_TYPE: 'UPDATE_USER_PREFERENCES_CLAIM_TYPE',
    UPDATE_USER_PREFERENCES_CONFIRM_SAVE_MODAL_VISIBILITY: 'UPDATE_USER_PREFERENCES_CONFIRM_SAVE_MODAL_VISIBILITY',
    UPDATE_USER_PREFERENCES_CSV_SEPARATOR: 'UPDATE_USER_PREFERENCES_CSV_SEPARATOR',
    UPDATE_USER_PREFERENCES_CURRENT_LANGUAGE_KEY: 'UPDATE_USER_PREFERENCES_CURRENT_LANGUAGE_KEY',
    UPDATE_USER_PREFERENCES_DBS_AUTO_SUBMIT: 'UPDATE_USER_PREFERENCES_DBS_AUTO_SUBMIT',
    UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS: 'UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS',
    UPDATE_USER_PREFERENCES_DEALER_DISPLAY_FORMAT: 'UPDATE_USER_PREFERENCES_DEALER_DISPLAY_FORMAT',
    UPDATE_USER_PREFERENCES_DONE: 'UPDATE_USER_PREFERENCES_DONE',
    UPDATE_USER_PREFERENCES_GENERAL_DATE_FORMAT: 'UPDATE_USER_PREFERENCES_GENERAL_DATE_FORMAT',
    UPDATE_USER_PREFERENCES_GENERAL_DECIMAL_FORMAT: 'UPDATE_USER_PREFERENCES_GENERAL_DECIMAL_FORMAT',
    UPDATE_USER_PREFERENCES_GENERAL_TIME_ZONE: 'UPDATE_USER_PREFERENCES_GENERAL_TIME_ZONE',
    UPDATE_USER_PREFERENCES_IS_SAVED: 'UPDATE_USER_PREFERENCES_IS_SAVED',
    UPDATE_USER_PREFERENCES_LANGUAGE_PRIMARY_LANGUAGE: 'UPDATE_USER_PREFERENCES_LANGUAGE_PRIMARY_LANGUAGE',
    UPDATE_USER_PREFERENCES_LOADING: 'UPDATE_USER_PREFERENCES_LOADING',
    UPDATE_USER_PREFERENCES_NEXT_LOCATION: 'UPDATE_USER_PREFERENCES_NEXT_LOCATION',
    UPDATE_USER_PREFERENCES_PART_RETURNS_NUMBER_OF_DAYS: 'UPDATE_USER_PREFERENCES_PART_RETURNS_NUMBER_OF_DAYS',
    UPDATE_USER_PREFERENCES_PART_RETURNS_STATUS: 'UPDATE_USER_PREFERENCES_PART_RETURNS_STATUS',
    UPDATE_USER_PREFERENCES_PRIMARY_LANGUAGE_KEY: 'UPDATE_USER_PREFERENCES_PRIMARY_LANGUAGE_KEY',
    UPDATE_USER_PREFERENCES_REIMBURSEMENT_RED_INDICATOR: 'UPDATE_USER_PREFERENCES_REIMBURSEMENT_RED_INDICATOR',
    UPDATE_USER_PREFERENCES_REIMBURSEMENT_YELLOW_INDICATOR: 'UPDATE_USER_PREFERENCES_REIMBURSEMENT_YELLOW_INDICATOR',
    UPDATE_USER_PREFERENCES_SUCCESS: 'UPDATE_USER_PREFERENCES_SUCCESS',
    UPDATE_USER_PREFERENCES_THEME_PREFERRED_THEME: 'UPDATE_USER_PREFERENCES_THEME_PREFERRED_THEME',
    UPDATE_USER_SECURITY_SUCCESS: 'UPDATE_USER_SECURITY_SUCCESS',
    UPDATE_USER_TERRITORIES: 'UPDATE_USER_TERRITORIES'
});



// WEBPACK FOOTER //
// ./src/user/actions-list.js